import React from "react";
import MergeDatePicker from "../../../../shared/MergeDatePicker";
import { EventTypePicker, RolePicker } from "../components";
import { AuditLogEventType, AuditLogRole } from "../../../../../models/Entities";
import UserPicker from "../../../../shared/UserPicker/UserPicker";

type AuditLogsFiltersProps = {
  startDate: Date | null;
  endDate: Date | null;
  eventType: AuditLogEventType | null;
  userId: number | null;
  role: AuditLogRole | null;
  onFilterChange: (
    key: "startDate" | "endDate" | "eventType" | "userId" | "role",
  ) => (value: any) => void;
};

const AuditLogsFilters = ({
  startDate,
  endDate,
  eventType,
  userId,
  role,
  onFilterChange,
}: AuditLogsFiltersProps) => {
  return (
    <div className="flex flex-row w-full gap-4">
      {/* user filter */}
      <div className="grow">
        <UserPicker userId={userId} onUserIdChange={onFilterChange("userId")} />
      </div>

      {/* role filter */}
      <div className="grow">
        <RolePicker role={role} onRoleChange={onFilterChange("role")} />
      </div>

      {/* eventType filter*/}
      <div className="grow">
        <EventTypePicker eventType={eventType} onEventTypeChange={onFilterChange("eventType")} />
      </div>

      {/* date filter */}
      <div className="grow">
        <MergeDatePicker
          selectedStartDate={startDate}
          selectedEndDate={endDate}
          onStartDateSet={onFilterChange("startDate")}
          onEndDateSet={onFilterChange("endDate")}
        />
      </div>
    </div>
  );
};

export default AuditLogsFilters;
